'use es6';

import { getTimestamp } from '../../common-message-format/operators/commonMessageFormatGetters';
export const areNMsApart = timeInMs => (messageA, messageB) => {
  const timestampA = getTimestamp(messageA);
  const timestampB = getTimestamp(messageB);
  return Math.abs(timestampA - timestampB) >= timeInMs;
};